module.exports = __webpack_public_path__ + "img/shining-nikki.de3807c.png";